import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import axios from "axios";

import { getConfig, searchAPI } from "../../../apis";
import CustomLoader from "../../../components/loader";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import QuillBox from "./QuillBox";
import { axiosInstance } from "../../../functions/axios";

const Comment = (props) => {
  const { commentPopup, setCommentPopup, collectionId, getBookmarks } = props;
  const [loading, setLoading] = useState(true);
  const [edit, setEdit] = useState(false);
  const [commentsList, setCommentsList] = useState();
  const [id, setId] = useState(null);

  const { user } = useSelector((state) => state.auth);
  const location = useLocation();

  const params = useParams();

  const commentRef = useRef(null);

  const getCommentList = async () => {
    const { data } = await axiosInstance.post(
      searchAPI.getNotes,
      {
        collectionSourceId: collectionId,
        userId: user.userId,
      },
      getConfig()
    );

    setCommentsList(data);
    setLoading(false);
  };

  const deleteNote = async (note_id) => {
    await axiosInstance.delete(searchAPI.deleteNote, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      data: {
        noteId: note_id,
        userId: user.userId,
      },
    });
    setId(null);
    setEdit(false);
    setLoading(true);
  };

  const addNotes = async () => {
    const quillEditor = document.querySelector(".ql-editor");
    const content = quillEditor.innerHTML;
    const request = {
      collectionSourceId: collectionId,
      userId: user.userId,
      noteText: content,
    };
    if (id && edit) {
      await axiosInstance.post(
        searchAPI.addUpdateNotes,
        {
          ...request,
          noteId: id,
        },
        getConfig()
      );
      setId(null);
      setEdit(false);
    } else {
      await axiosInstance.post(searchAPI.addUpdateNotes, request, getConfig());
    }
    setLoading(true);
  };

  const handleClose = () => {
    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.get("search");
    getBookmarks(params.id);
    setCommentPopup(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (commentRef.current && !commentRef.current.contains(event.target)) {
        setCommentPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setCommentPopup]);

  useEffect(() => {
    getCommentList();
  }, [loading]);

  return (
    commentPopup && (
      <>
        <div className="new-comment-popup">
          <div className="bg-dark" />
          <div className="popup-card" ref={commentRef}>
            <CloseIcon
              className="cross"
              onClick={() => {
                handleClose();
              }}
            />
            {loading ? (
              <CustomLoader />
            ) : (
              <>
                <p className="popup-title">Add Your Notes here </p>

                <div className="comments-section">
                  {commentsList.map((commentItem, index) => (
                    <div key={index} className="comment-item">
                      <span className="header">
                        <p>
                          {commentItem.userEmail_chr} {" - "}{" "}
                        </p>
                        <div>
                          {commentItem.allowDelete_ysn && (
                            <DeleteIcon
                              className="edit mr-1"
                              onClick={() => {
                                deleteNote(commentItem.noteId_ids);
                              }}
                            />
                          )}{" "}
                          {commentItem.allowModification_ysn && (
                            <ModeEditIcon
                              className="edit mr-1"
                              onClick={() => {
                                setId(commentItem.noteId_ids);
                                setEdit(true);
                              }}
                            />
                          )}
                          {id === commentItem.noteId_ids && edit && (
                            <CloseIcon
                              className="edit"
                              onClick={() => {
                                setId(null);
                                setEdit(false);
                              }}
                            />
                          )}
                        </div>
                      </span>
                      <div
                        className="comment-container"
                        style={{ overflowY: edit ? "hidden" : "auto" }}
                      >
                        {id === commentItem.noteId_ids && edit ? (
                          <QuillBox
                            edit={true}
                            initialText={commentItem.noteText_chr}
                          />
                        ) : (
                          <div className="comment-content">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: `${commentItem.noteText_chr}`,
                              }}
                            ></span>{" "}
                          </div>
                        )}
                      </div>
                      <br />
                    </div>
                  ))}
                </div>

                <div className="comment-form">
                  {!edit && <QuillBox initialText="" />}
                </div>
                <br />

                <div className="save-actions">
                  <div />
                  <div className="flex">
                    <ButtonPrimary
                      text="Cancel"
                      onClick={() => {
                        setEdit(false);
                        getBookmarks(params.id);
                        setCommentPopup(false);
                      }}
                      className="mr-2 grey"
                      outline
                    />
                    <ButtonPrimary
                      text={id && edit ? "Update" : "Add"}
                      onClick={addNotes}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </>
    )
  );
};

export default Comment;
